<template>
    <div v-show="query !== ''">
        <ais-instant-search
            :search-client="searchClient"
            :index-name="index"
            :search-function="searchFunction"
            :middlewares="middlewares"
            :routing="routing"
            :clickAnalytics="true"
            :insights="true"
        >
            <ais-configure
                :query="query"
                :clickAnalytics="true"
                :enablePersonalization="true"
                :analytics-tags.camel="['SEARCH_LIST']"
            />

            <!-- Filters -->
            <filter-panel-mobile :filters="categoryFilters"/>

            <div class="row">
                <filter-panel
                    :filters="categoryFilters"
                    class="col-12 col-md-4 col-lg-3 algolia-listing-filters d-none d-md-block"
                />
                <algolia-search-results
                    page-type="Search"
                    :lang-iso="langIso"
                    :user-token="userToken"
                    :action-banners="[]"
                    class="col-12 col-md-8 col-lg-9"
                />
            </div>

            <algolia-search-no-results/>
        </ais-instant-search>
    </div>
</template>

<script>
import {
    algoliaClientShortTTL,
    getAlgoliaInsightsAnonymousToken,
    getAlgoliaInsightsToken,
    index,
} from "../../js/algoliaSettings";
import AlgoliaSearchResults from "./AlgoliaSearchResults";
import AlgoliaSearchNoResults from "./AlgoliaSearchNoResults";
import FilterPanelMobile from "./Partials/FilterPanelMobile";
import FilterPanel from "./Partials/FilterPanel";
import { AisConfigure, AisInstantSearch, AisRefinementList, AisStats } from "vue-instantsearch/vue3/es";
import aa from "search-insights";
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import { history as historyRouter } from "instantsearch.js/es/lib/routers";
import { AlgoliaSearchHelper } from "algoliasearch-helper";

const insightsMiddleware = createInsightsMiddleware({
    insightsClient: aa,
    insightsInitParams: {
        useCookie: true,
    }
});

const changeDisplayOnComponents = (type = "hide") => {
    const displayStyle = type === "show" ? "block" : "none";

    if (document.getElementById("center_column")) {
        document.getElementById("center_column").style.display = displayStyle;
    }

    if (document.getElementById("right-column")) {
        document.getElementById("right-column").style.display = displayStyle;
    }

    if (document.getElementById("js_mobileMenuHome")) {
        document.getElementById("js_mobileMenuHome").style.display = displayStyle;
    }

    if (typeof is_mobile !== "undefined") {
        if (is_mobile) {
            if (document.getElementById("brekz_topmenu")) {
                document.getElementById(
                    "brekz_topmenu"
                ).style.display = displayStyle;
            }

            const menuTops = document.getElementsByClassName("menu-top");
            Array.from(menuTops).forEach(el => {
                el.style.display = displayStyle;
            });

            const usps = document.getElementsByClassName("usps");
            Array.from(usps).forEach(el => {
                el.style.display = displayStyle;
            });
        }
    }
};

export default {
    components: {
        AisInstantSearch,
        AisRefinementList,
        AisStats,
        AisConfigure,
        AlgoliaSearchResults,
        AlgoliaSearchNoResults,
        FilterPanel,
        FilterPanelMobile
    },
    props: {
        categoryFilters: {
            type: Array,
            required: true,
            default: () => []
        },
        categoryId: {
            type: Number,
            required: false,
            default: 0
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
        userPersonalisationIdentifier: {
            type: Number,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            searchClient: algoliaClientShortTTL(),

            /** @param {AlgoliaSearchHelper} helper */
            searchFunction(helper) {
                if (helper.state.query && helper.state.query !== "") {
                    const oldSearchQuery = localStorage.getItem('brekz_algolia_search_query');
                    if (helper.state.query !== oldSearchQuery
                        && oldSearchQuery !== null
                        && this.hasSearchedBefore) {
                        helper.clearRefinements();
                    }

                    let params = new URLSearchParams(window.location.search);

                    if (params.has('disableCache') && params.get('disableCache') == '1') {
                        localStorage.removeItem('algoliasearch-client-js-responses-cache');
                        localStorage.removeItem('algoliasearch-client-js-responses-cache-short');
                    }


                    this.hasSearchedBefore = true;
                    try {
                        localStorage.setItem('brekz_algolia_search_query', helper.state.query);
                    } catch(e) {
                        console.log(e);
                        helper.search();
                        return;
                    }
                    helper.search();
                }
            },
            index: index(),
            userToken: null,
            hasSearchedBefore: false,
            query: "",
            middlewares: [insightsMiddleware],
            routing: {
                router: historyRouter({

                    createURL({ qsModule, routeState, location }) {

                        const queryParameters = {};

                        const searchParams = new URLSearchParams(location.search);

                        if (searchParams.has("query")) {
                            queryParameters.query = searchParams.get("query");
                        } else if (routeState.query) {
                            queryParameters.query = encodeURIComponent(routeState.query);

                        }

                        if (routeState.page !== 1) {
                            queryParameters.page = routeState.page;
                        }

                        if (routeState.refinementList) {
                            queryParameters.filter = routeState.refinementList;
                        }

                        const queryString = qsModule.stringify(queryParameters, {
                            addQueryPrefix: true,
                            arrayFormat: 'repeat'
                        });

                        return `${queryString}`;
                    },

                    parseURL({ qsModule, location }) {

                        const { query = '', page, filter = {} } = qsModule.parse(
                            location.search.slice(1)
                        );

                        for(const property in filter) {
                            const item       = filter[property];
                            filter[property] = Array.isArray(item) ? item : [item].filter(Boolean);
                        }

                        return {
                            query: decodeURIComponent(query),
                            page,
                            refinementList: filter,
                        };
                    }
                }),
                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[index()] || {};

                        return {
                            query: indexUiState.query,
                            page: indexUiState.page,
                            refinementList: indexUiState.refinementList,
                        };
                    },
                    routeToState(routeState) {
                        return {
                            [index()]: {
                                query: routeState.query,
                                page: routeState.page,
                                refinementList: routeState.refinementList
                            }
                        };
                    }
                },
            }
        };
    },
    created() {
        this.configureAlgoliaInsights();
    },
    methods: {
        configureAlgoliaInsights() {
            let userToken = getAlgoliaInsightsAnonymousToken();

            if (this.userPersonalisationIdentifier) {
                userToken = getAlgoliaInsightsToken(this.userPersonalisationIdentifier);
            }

            aa('setUserToken', userToken);
            this.userToken = userToken;
        }
    },
    mounted() {
        EventBus.$on("search-input-hit", query => {
            if (query === null || query === "") {
                this.query = "";
                changeDisplayOnComponents("show");

                if (document.getElementsByTagName('body')[0].getAttribute('id') !== 'category') {
                    if (document.getElementById("orders-button-bottom")) {
                        document.getElementById("orders-button-bottom").classList.remove('d-none');
                    }
                    if (document.getElementById("filters-button-bottom")) {
                        document.getElementById("filters-button-bottom").classList.add('d-none');
                    }
                }
            } else {
                this.query = query;
                changeDisplayOnComponents("hide");


                if (document.getElementById("orders-button-bottom")) {
                    document.getElementById("orders-button-bottom").classList.add('d-none');
                }

                if (document.getElementById("filters-button-bottom")) {
                    document.getElementById("filters-button-bottom").classList.remove('d-none');
                }
            }
        });
    }
};
</script>
